import type { ButtonProps } from '@mui/material';
import MuIButton from '@mui/material/Button';
import { forwardRef } from 'react';

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  return <MuIButton ref={ref} {...props} />;
});
Button.displayName = 'Button';
export default Button;
